import { Apple360SpinModel } from '@app-types/apple-360-spin';

import { PRODUCT_3D_VIEWER_MESSAGES } from '@constants/product-3d';

export enum Product3dProvider {
    APPLE_360_SPIN = 'APPLE_360_SPIN',
}

export type Product3dModel = Apple360SpinModel;

export type Product3dViewer = {
    name: string;
    url: string;
};

// Posted by the viewer document to its parent page
export type Product3dViewerMessage = {
    type: typeof PRODUCT_3D_VIEWER_MESSAGES.COLOR_SELECT;
    color: string;
};
